import Swal from "sweetalert2";

const AlertA = (position, icon, title, timer, textcolor, iconColor) =>
  Swal.fire({
    position: position,
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: timer,
    color: textcolor ? textcolor : "",
    iconColor: iconColor ? textcolor : "",
  });

export default AlertA;
